/* eslint-disable camelcase */
/* eslint-disable @typescript-eslint/no-magic-numbers */

import type { DeferredPaymentConfig } from '@twisto/api-cms'

export const calculatorConfigPL: DeferredPaymentConfig = {
  plan: [[1000000, 0.16083]],
  active_from: '2026-01-21T13:03:42.101736+01:00',
  divider_amount: 10,
  capital_interest_rate: '15.5000',
  annual_percentage_rate: '40.95',
  capital_interest_example: '1.2917',
  deferral_charge_example: '2.9017',
  non_interest_deferral_fee_example: '1.6100',
}
export const calculatorConfigCZ: DeferredPaymentConfig = {
  plan: [
    [5000, 4.9],
    [6000, 4.4],
    [8000, 3.9],
    [10000, 3.4],
    [12000, 2.9],
    [13000, 2.9],
    [15000, 2.9],
    [20000, 2.6],
    [30000, 2.4],
    [40000, 2.2],
    [1000000, 1],
  ],
  active_from: '2026-01-21T13:03:42.101736+01:00',
  divider_amount: 100,
  capital_interest_rate: null,
  annual_percentage_rate: null,
  capital_interest_example: null,
  deferral_charge_example: null,
  non_interest_deferral_fee_example: null,
}
